export default {
  wrapper: {
    maxWidth: '100%',
    height: '100vh',
    background: '#F9FAFC',
  },
  containerRight: {
    width: '100%',
    overflow: 'auto',
  },
  body: {
    flex: 1,
    overflow: 'scroll',
  },
};
